export default "__VITE_ASSET__ZOA5DkfC__"